import { createFileRoute } from "@tanstack/react-router";
import { SitemapRedirect } from "@/components/layout/SitemapRedirect";

export const Route = createFileRoute("/sitemap-ro.xml/")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <SitemapRedirect country="ro" />
  );
}
